/* Mi tienda 4 — scripts propios. Todo vanilla, sin librerías. */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Animaciones de entrada ---------- */
  function initReveals() {
    var items = document.querySelectorAll('.mt-reveal');
    if (!items.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('mt-visible'); });
      return;
    }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        /* Visible ahora, o ya lo hemos dejado atrás al recargar/saltar a un ancla */
        if (e.isIntersecting || e.boundingClientRect.top < 0) {
          e.target.classList.add('mt-visible');
          obs.unobserve(e.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    items.forEach(function (el) { obs.observe(el); });
  }

  /* ---------- Parallax suave del hero ---------- */
  function initParallax() {
    var imgs = document.querySelectorAll('[data-mt-parallax]');
    if (!imgs.length || reduce) return;
    var ticking = false;
    function update() {
      imgs.forEach(function (img) {
        var wrap = img.parentElement;
        var r = wrap.getBoundingClientRect();
        if (r.bottom < 0 || r.top > window.innerHeight) return;
        var fuerza = parseFloat(img.getAttribute('data-mt-parallax')) || 0;
        if (!fuerza) return;
        var avance = (r.top + r.height / 2 - window.innerHeight / 2) / window.innerHeight;
        img.style.transform = 'translate3d(0,' + (avance * fuerza * -1).toFixed(2) + 'px,0) scale(1.12)';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
    }, { passive: true });
    update();
  }

  /* ---------- Marquesina ---------- */
  function initMarquee() {
    document.querySelectorAll('.mt-marquee__pista').forEach(function (pista) {
      if (pista.dataset.mtClonada === '1') return;
      pista.dataset.mtClonada = '1';
      var copia = pista.innerHTML;
      pista.innerHTML = copia + copia;
    });
  }

  /* ---------- FAQ ---------- */
  function initFaq() {
    document.querySelectorAll('.mt-faq__btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.mt-faq__item');
        var panel = item.querySelector('.mt-faq__panel');
        var abierto = item.classList.contains('mt-abierto');
        var lista = item.closest('.mt-faq__lista');
        if (lista) {
          lista.querySelectorAll('.mt-faq__item.mt-abierto').forEach(function (otro) {
            if (otro === item) return;
            otro.classList.remove('mt-abierto');
            otro.querySelector('.mt-faq__panel').style.height = '0px';
            otro.querySelector('.mt-faq__btn').setAttribute('aria-expanded', 'false');
          });
        }
        if (abierto) {
          item.classList.remove('mt-abierto');
          panel.style.height = '0px';
          btn.setAttribute('aria-expanded', 'false');
        } else {
          item.classList.add('mt-abierto');
          panel.style.height = panel.scrollHeight + 'px';
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  /* ---------- Galería del producto ---------- */
  function initGaleria() {
    var galeria = document.querySelector('[data-mt-galeria]');
    if (!galeria) return;
    var principal = galeria.querySelector('[data-mt-principal]');
    galeria.querySelectorAll('[data-mt-mini]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var src = btn.getAttribute('data-mt-src');
        if (!src || !principal) return;
        principal.src = src;
        principal.srcset = '';
        galeria.querySelectorAll('[data-mt-mini]').forEach(function (b) { b.classList.remove('mt-activa'); });
        btn.classList.add('mt-activa');
      });
    });
  }

  /* ---------- Selector de variantes ---------- */
  function initVariantes() {
    var raiz = document.querySelector('[data-mt-producto]');
    if (!raiz) return;
    var datos = raiz.querySelector('[data-mt-variantes]');
    if (!datos) return;

    var variantes;
    try { variantes = JSON.parse(datos.textContent); } catch (e) { return; }
    if (!variantes || !variantes.length) return;

    var inputId = raiz.querySelector('[data-mt-variant-id]');
    var elPrecio = raiz.querySelector('[data-mt-precio]');
    var elAntes = raiz.querySelector('[data-mt-antes]');
    var boton = raiz.querySelector('[data-mt-add]');
    var aviso = raiz.querySelector('[data-mt-aviso]');
    var textoAgotado = raiz.getAttribute('data-mt-texto-agotado') || 'Agotado';
    var textoAdd = boton ? boton.getAttribute('data-mt-texto') || boton.textContent.trim() : '';
    var moneda = raiz.getAttribute('data-mt-moneda') || '€';

    function formatea(centimos) {
      var n = (centimos / 100).toFixed(2).replace('.', ',');
      return n + ' ' + moneda;
    }

    function seleccionadas() {
      return Array.prototype.map.call(
        raiz.querySelectorAll('[data-mt-opcion]'),
        function (grupo) {
          var sel = grupo.querySelector('.mt-sel');
          return sel ? sel.getAttribute('data-mt-valor') : null;
        }
      );
    }

    function buscar(sel) {
      for (var i = 0; i < variantes.length; i++) {
        var v = variantes[i];
        var ok = true;
        for (var j = 0; j < sel.length; j++) {
          if (sel[j] !== null && v.options[j] !== sel[j]) { ok = false; break; }
        }
        if (ok) return v;
      }
      return null;
    }

    function marcaDisponibilidad(sel) {
      raiz.querySelectorAll('[data-mt-opcion]').forEach(function (grupo, idx) {
        grupo.querySelectorAll('[data-mt-valor]').forEach(function (btn) {
          var prueba = sel.slice();
          prueba[idx] = btn.getAttribute('data-mt-valor');
          var hay = variantes.some(function (v) {
            for (var j = 0; j < prueba.length; j++) {
              if (j !== idx && prueba[j] !== null && v.options[j] !== prueba[j]) return false;
            }
            return v.options[idx] === prueba[idx] && v.available;
          });
          btn.classList.toggle('mt-agotado', !hay);
        });
      });
    }

    function actualiza() {
      var sel = seleccionadas();
      var v = buscar(sel);
      marcaDisponibilidad(sel);

      if (!v) {
        if (boton) { boton.disabled = true; boton.textContent = textoAgotado; }
        return;
      }
      if (inputId) inputId.value = v.id;
      if (elPrecio) elPrecio.textContent = formatea(v.price);
      if (elAntes) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          elAntes.textContent = formatea(v.compare_at_price);
          elAntes.hidden = false;
        } else {
          elAntes.hidden = true;
        }
      }
      if (boton) {
        boton.disabled = !v.available;
        boton.textContent = v.available ? textoAdd : textoAgotado;
      }
      if (aviso) aviso.hidden = v.available;

      if (v.featured_image && v.featured_image.src) {
        var principal = raiz.querySelector('[data-mt-principal]');
        if (principal) { principal.src = v.featured_image.src; principal.srcset = ''; }
        var mini = raiz.querySelector('[data-mt-mini][data-mt-media-id="' + v.featured_image.id + '"]');
        if (mini) {
          raiz.querySelectorAll('[data-mt-mini]').forEach(function (b) { b.classList.remove('mt-activa'); });
          mini.classList.add('mt-activa');
        }
      }

      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    raiz.querySelectorAll('[data-mt-valor]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var grupo = btn.closest('[data-mt-opcion]');
        grupo.querySelectorAll('[data-mt-valor]').forEach(function (b) { b.classList.remove('mt-sel'); });
        btn.classList.add('mt-sel');
        actualiza();
      });
    });

    actualiza();
  }

  function init() {
    initReveals();
    initParallax();
    initMarquee();
    initFaq();
    initGaleria();
    initVariantes();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* El editor de Shopify recarga secciones sueltas: re-inicializa */
  document.addEventListener('shopify:section:load', init);
})();
